import { getStore } from '~/mobx/AppStore';

export const getIsLoading = () => {
    const { reportStore } = getStore();

    return (
        reportStore.isGettingUserVoteCount ||
        reportStore.isLoadingStandAdminUserVoteList ||
        reportStore.isGettingCandidateScoreList ||
        reportStore.isSendingReportFile
    );
};
